import { render, staticRenderFns } from "./descriptions.vue?vue&type=template&id=fbf9001e&scoped=true"
import script from "./descriptions.vue?vue&type=script&lang=js"
export * from "./descriptions.vue?vue&type=script&lang=js"
import style0 from "./descriptions.vue?vue&type=style&index=0&id=fbf9001e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf9001e",
  null
  
)

export default component.exports